import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

import documentationAddItem from '@/components/documentation/documentationAddItem';

import Api from '@/utils/api';

export default {
  components: {
    vueDropzone: vue2Dropzone,
    documentationAddItem,
  },
  data() {
    return {
      dropzoneOptions: {
        url: '/',
        autoProcessQueue: false,
        thumbnailWidth: 150,
        maxFiles: 3,
        dictDefaultMessage: '<div class="dropzone-icon"><svg class="icon"><use xlink:href="/img/icons/icons-sprite.svg#drop-file-zone"/></svg></div><div class="dropzone-text">Choose a file or drag it here<br>(*.jpg, *.jpeg, *.png, *.pdf, max size 5mb)</div>',
        addedfile: (file) => {
          const acceptedExtensions = ['png', 'pdf', 'jpg', 'jpeg'];
          const fileExtension = file.type.split('/')[1].toString();
          if (!acceptedExtensions.includes(fileExtension)) {
            return this.$root.$emit('notification', {
              message: `file extension mustbe either of : <br/> ${acceptedExtensions.map((el) => ' ' + el + ' ')}`,
              type: 'error',
              show: true,
            });
          }

          if ((file.size / (1000 * 1000)) > 5) {
            return this.$root.$emit('notification', {
              message: `Size file: ${file.name} more 5 MB`,
              type: 'error',
              show: true,
            });
          }
          this.getDocumentContentAsJson(file)
            .then((data) => {
              file.dataURL = data;
              return this.addUploadFile(file);
            });
        },
        acceptedFiles: '.png,.jpeg,.pdf,.jpg',
      },

      documentationData: [],

      langList: [],
      errorCategoryList: [],
      accessList: [],
    };
  },
  created() {
    this.getFilter();
  },
  methods: {

    /**
     * Method for upload files
     *
     * @param {Object} file
     */
    addUploadFile(file) {
      this.documentationData.push({
        Name: file.name,
        DataUrl: file.dataURL,
        FileSize: file.size,
        FileType: `.${file.name.split('.').pop()}`,
        TextCategory: [],
        Language: {},
        Access: [],
      });
    },

    /**
     * Method for get content from file
     *
     * @param {Object} file
     */
    getDocumentContentAsJson(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },

    uploadFiles() {
      if (this.documentationData.filter((el) => el.TextCategory.length === 0 && el.Access.length === 0).length !== 0) {
        this.$root.$emit('notification', {
          message: 'Document Category and Document Access Rights fields are required',
          type: 'error',
          show: true,
        });
      } else {
        Api.documentation
          .upload(this.documentationData)
          .then((response) => {
            if (response.status === 200 || response.status === 204) {
              this.$root.$emit('notification', {
                message: 'Files was uploaded!',
                type: 'info',
                show: true,
              });
              setTimeout(() => {
                this.$router.push('/documentation/tile');
              }, 2000);
            } else {
              this.$root.$emit('notification', {
                type: 'error',
                show: true,
                listError: response.data.ErrorValues,
              });
            }
          });
      }
    },

    /**
     * Method for reset files data
     */
    resetFiles() {
      this.$modal.show('dialog', {
        title: 'remove all documents',
        text: 'Do you want to delete all documents from upload list?',
        buttons: [{
          title: 'Yes',
          handler: () => {
            this.documentationData = [];
            this.$modal.hide('dialog');
          },
        }, {
          title: 'No',
        }],
      });
    },

    removeFile(idx) {
      this.documentationData.splice(idx, 1);
    },

    async reuploadFile(idx, file) {
      const data = await this.getDocumentContentAsJson(file);
      file.dataURL = data;
      this.documentationData[idx] = {
        Name: file.name,
        DataUrl: file.dataURL,
        FileSize: file.size,
        FileType: `.${file.name.split('.').pop()}`,

        Client: [...file.Client],
        TextCategory: [...file.TextCategory],
        Language: {
          ...file.Language,
        },
        Access: [...file.Access],
      };
    },
    /**
     * Get all filters
     */
    getFilter() {
      Api.getLanguage()
        .then((reposnse) => {
          if (reposnse.status === 200) {
            this.langList = reposnse.data;
          }
        });

      Api.settings.errorConfiguration
        .get()
        .then((response) => {
          if (response.status) {
            this.errorCategoryList = response.data.Data;
          }
        });

      Api.user
        .getAccounts()
        .then((reposnse) => {
          if (reposnse.data.Status) {
            this.accessList = reposnse.data.Data;
          }
        });
    },

  },
};
